import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
export function UrgencySection() {
  const initialTime = 2 * 3600 + 12 * 60 + 18;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev <= 0 ? initialTime : prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [initialTime]);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black py-4 px-4 font-sans border-t border-gray-800" data-id="element-492">
      <div className="max-w-4xl mx-auto text-center" data-id="element-493">
        <h2 className="text-2xl md:text-4xl font-black text-white uppercase tracking-wide mb-3" data-id="element-494">
          EL PRECIO DE LANZAMIENTO TERMINA EN
        </h2>

        {/* Countdown Timer */}
        <div className="flex justify-center items-start gap-1.5 md:gap-2 mb-3" data-id="element-495">
          <div className="flex flex-col items-center" data-id="element-496">
            <div className="bg-[#111111] border-2 border-gray-700 rounded-lg w-14 h-16 md:w-20 md:h-22 flex items-center justify-center shadow-[0_0_15px_rgba(0,0,0,0.3)]" data-id="element-497">
              <span className="text-4xl md:text-6xl font-black text-red-500 drop-shadow-[0_0_10px_rgba(239,68,68,0.5)]" data-id="element-498">
                {formatNumber(hours)}
              </span>
            </div>
            <span className="text-gray-400 text-[10px] md:text-xs font-bold mt-1 tracking-widest uppercase" data-id="element-499">
              Horas
            </span>
          </div>

          <div className="text-2xl md:text-4xl font-black text-red-500 mt-2 md:mt-3 animate-pulse" data-id="element-500">
            :
          </div>

          <div className="flex flex-col items-center" data-id="element-501">
            <div className="bg-[#111111] border-2 border-gray-700 rounded-lg w-14 h-16 md:w-20 md:h-22 flex items-center justify-center shadow-[0_0_15px_rgba(0,0,0,0.3)]" data-id="element-502">
              <span className="text-4xl md:text-6xl font-black text-red-500 drop-shadow-[0_0_10px_rgba(239,68,68,0.5)]" data-id="element-503">
                {formatNumber(minutes)}
              </span>
            </div>
            <span className="text-gray-400 text-[10px] md:text-xs font-bold mt-1 tracking-widest uppercase" data-id="element-504">
              Minutos
            </span>
          </div>

          <div className="text-2xl md:text-4xl font-black text-red-500 mt-2 md:mt-3 animate-pulse" data-id="element-505">
            :
          </div>

          <div className="flex flex-col items-center" data-id="element-506">
            <div className="bg-[#111111] border-2 border-gray-700 rounded-lg w-14 h-16 md:w-20 md:h-22 flex items-center justify-center shadow-[0_0_15px_rgba(0,0,0,0.3)]" data-id="element-507">
              <span className="text-4xl md:text-6xl font-black text-red-500 drop-shadow-[0_0_10px_rgba(239,68,68,0.5)]" data-id="element-508">
                {formatNumber(seconds)}
              </span>
            </div>
            <span className="text-gray-400 text-[10px] md:text-xs font-bold mt-1 tracking-widest uppercase" data-id="element-509">
              Segundos
            </span>
          </div>
        </div>

        {/* Urgency Badges */}
        <div className="flex flex-wrap justify-center gap-1.5 md:gap-3 mb-3" data-id="element-510">
          <div className="bg-[#111111] border border-gray-700 text-gray-300 px-2.5 py-1 rounded-md text-sm md:text-base font-medium flex items-center gap-1.5" data-id="element-511">
            <span data-id="element-512">👥</span> Últimos cupos disponibles
          </div>
          <div className="bg-[#111111] border border-gray-700 text-gray-300 px-2.5 py-1 rounded-md text-sm md:text-base font-medium flex items-center gap-1.5" data-id="element-513">
            <span data-id="element-514">🚀</span> Oferta de Lanzamiento
          </div>
          <div className="bg-[#111111] border border-gray-700 text-gray-300 px-2.5 py-1 rounded-md text-sm md:text-base font-medium flex items-center gap-1.5" data-id="element-515">
            <span data-id="element-516">📈</span> Precio sube al terminar
          </div>
        </div>

        {/* Progress Bar */}
        <div className="max-w-sm mx-auto mb-3" data-id="element-517">
          <div className="text-gray-300 text-sm font-bold mb-1 tracking-wider" data-id="element-518">
            92% DE CUPOS OCUPADOS
          </div>
          <div className="h-2.5 w-full bg-[#111111] rounded-full overflow-hidden border border-gray-700" data-id="element-519">
            <div className="h-full bg-red-600 rounded-full" style={{
            width: '92%'
          }} data-id="element-520"></div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="flex justify-center" data-id="element-521">
          <CTAButton onClick={scrollToPricing} className="w-full md:w-auto px-8 md:px-14 py-3 text-xl shadow-[0_0_20px_rgba(34,197,94,0.4)]" data-id="element-522">
            🔒 ASEGURAR MI PRECIO AHORA
          </CTAButton>
        </div>
      </div>
    </section>;
}